import styled from "styled-components";
import { COLORS } from "../../assets/constants/styles";

export const Container = styled.div`
  width: 100%;
`;

export const TitleSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;
`;

export const ControlsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Subtitle = styled.p`
  font-size: 1rem;
  color: ${COLORS.grey};
  margin: 0;
`;

export const ErrorMessage = styled.div`
  color: ${COLORS.red};
  margin-bottom: 1rem;
  padding: 0.75rem;
  background-color: ${COLORS.lightRed};
  border-radius: 0.25rem;
`;

export const RetryLink = styled.span`
  color: ${COLORS.violet};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${COLORS.darkViolet};
  }
`;
